import { cn } from "./cn";

const labels = ["Too short", "Weak", "Fair", "Strong", "Excellent"] as const;
const tones = [
  "bg-line",
  "bg-danger",
  "bg-warning",
  "bg-success",
  "bg-success",
] as const;

/** Cheap, transparent heuristic — length first, then character variety. */
export function scorePassword(value: string) {
  if (value.length < 8) return 0;
  let score = 1;
  if (value.length >= 12) score++;
  if (/[a-z]/.test(value) && /[A-Z]/.test(value)) score++;
  if (/\d/.test(value) && /[^\w\s]/.test(value)) score++;
  return Math.min(4, score);
}

export function PasswordStrength({ value }: { value: string }) {
  const score = scorePassword(value);

  return (
    <div className="mt-2" aria-live="polite">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((step) => (
          <span
            key={step}
            className={cn(
              "h-1 flex-1 rounded-full transition-colors duration-200",
              step <= score ? tones[score] : "bg-line",
            )}
          />
        ))}
      </div>
      <p className="mt-1.5 text-2xs text-ink-4">
        {value ? (
          <>
            <span className="font-semibold text-ink-3">{labels[score]}</span> — use 12+
            characters with a mix of cases, a number and a symbol.
          </>
        ) : (
          "At least 12 characters."
        )}
      </p>
    </div>
  );
}
